import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, switchMap, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import * as fileSaver from 'file-saver';
import { getFileNameFromHttpResponse, getUrlParam } from './helpers';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ApplicationService,
  SmartgemRoadConditionReportRequestRoadConditionReportInputDto
} from '../openapi';
import { ConfirmDrawEvent } from '../common/exposed-map/exposed-map.component';

@Injectable({
  providedIn: 'root'
})
export class SmartGemCommonService {
  constructor(
    private http: HttpClient,
    private applicationService: ApplicationService
  ) {
  }

  public getRatesCollection(eServiceId: string, data: ConfirmDrawEvent): Observable<any> {
    return this.http.post(
      `${environment.apiBasePath}/smartgem/rates`,
      {
        eServiceId,
        geometries: data.params.geometries.map(v => ({
          ...v,
          crs: {
            type: 'name',
            properties: {
              name: 'EPSG:2180'
            }
          }
        }))
      },
      { observe: 'body', responseType: 'json' }
    ).pipe(
      map((data: any) => data?.rates || []),
      catchError(() => of([]))
    );
  }

  public downloadRoadConditionReportPdf(value: SmartgemRoadConditionReportRequestRoadConditionReportInputDto): Observable<any> {
    return this.http.post(`${environment.apiBasePath}/smartgem/road-condition/report`, value, {
      observe: 'response',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    }).pipe(
      tap((resp) => {
        fileSaver.saveAs(resp.body || '', getFileNameFromHttpResponse(resp) || 'example.pdf');
      })
    );
  }

  public getTrafficOrganizationDesignURL(payload: ApplicationAppEntityApplicationWrite): Observable<ApplicationAppEntityApplicationRead> {
    return this.applicationService.postApplicationApplicationCollection({
      application: {
        geometry: payload.geometry,
        service: payload.service,
        applicationSubject: payload.applicationSubject,
        projectType: payload.projectType
      }
    }).pipe(
      switchMap(application =>
        this.http.post(`${environment.apiBasePath}/application/${application.uuid}/por/generate`, { geometry: payload.geometry }, {
          observe: 'body',
          responseType: 'json'
        }).pipe(
          map(v => v as any),
          map((resp: {
            success: boolean,
            porUrl: string,
            externalId: string
          }) => {
            return resp.porUrl;
          }),
          switchMap((v) =>
            this.applicationService.patchApplicationApplicationItem({
              id: application.uuid || '',
              application: {
                porAssignmentApplication: getUrlParam('por', v) || undefined,
                description: v
              }
            })
          )
        )
      )
    );
  }

  public submitTrafficOrganizationDesign(payload: ApplicationAppEntityApplicationWrite, appId: string): Observable<ApplicationAppEntityApplicationRead> {
    return this.http.post(`${environment.apiBasePath}/application/${appId}/por/submit`, payload);
  }
}
